/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

export const makeAssociationsDiff = (
  current: string[] = [],
  next: string[] = [],
): { add: string[]; remove: string[] } => {
  const currentIds = new Set(current)
  const nextIds = new Set(next)

  const add = next.filter((id) => !currentIds.has(id))
  const remove = current.filter((id) => !nextIds.has(id))

  return { add, remove }
}
